import { useBaseSelectContext } from '~/components/granular';
import { BackButtonContainer, BackButtonControl } from '~/components/granular/back-button';

interface BackButtonProps {
  visible: boolean;
  onClick: () => void;
}

export function BackButton({ visible, onClick }: BackButtonProps) {
  const { backLabel } = useBaseSelectContext();

  if (!visible) {
    return null;
  }

  return (
    <BackButtonContainer>
      <BackButtonControl onClick={onClick}>{backLabel}</BackButtonControl>
    </BackButtonContainer>
  );
}
